<script setup lang="ts">
import dayjs from '@sancare/typescript-commons/src/misc/dayjs'
import { computed } from 'vue'

import { Rhs } from '@/store/modules/stay/smr/types'

const props = withDefaults(
  defineProps<{
    rhs: Rhs
    mode?: 'labeled' | null
  }>(),
  {
    mode: null,
  }
)

const getMode = computed(() => (props.mode === 'labeled' ? 'week-day-labeled' : 'week-day'))
const presenceDays = computed(() =>
  [...props.rhs.weekDays.split(''), ...props.rhs.weekEndDays.split('')].map((day) => Boolean(Number(day)))
)
const weekDayTooltips = computed(() => dayjs.weekdays(true))
const weekDayLabels = ['L', 'M', 'M', 'J', 'V', 'S', 'D']
</script>

<template>
  <div
    v-for="(day, idx) in presenceDays"
    :key="idx"
    v-tooltip="weekDayTooltips[idx]"
    :class="[getMode, { presence: day }]"
  >
    <template v-if="mode === 'labeled'">
      {{ weekDayLabels[idx] }}
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import '@sancare/typescript-commons/src/assets/styles/variables';

.week-day {
  display: inline-block;
  width: 13px;
  height: 13px;
  margin-right: 2px;
  background-color: $sancare-light-grey;
  border-radius: 2px;
  transition: background-color .2s ease;

  &.presence {
    background-color: $sancare-green;
  }

  &-labeled {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background-color: #d3d3d3;
    font-size: 10px;
    font-weight: 600;
    color: #666666;
    cursor: pointer;
    border-radius: 2px;
    transition: background-color .2s ease;

    &.presence {
      background-color: #808080;
      color: #ffffff;
    }
  }
}
</style>